"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tossicia": {
    "878edb1d": [{
      "hkey": "4f233fe1",
      "slug": "tossicia",
      "name": "Tossicia",
      "primary": true,
      "skipSearch": false
    }],
    "aquilano": [{
      "hkey": "4f233fe1",
      "slug": "tossicia",
      "name": "Tossicia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "199ba53e": [{
      "hkey": "4f233fe1",
      "slug": "tossicia",
      "name": "Tossicia",
      "primary": true,
      "skipSearch": false
    }],
    "azzinano": [{
      "hkey": "4f233fe1",
      "slug": "tossicia",
      "name": "Tossicia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c68a0d5d": [{
      "hkey": "4f233fe1",
      "slug": "tossicia",
      "name": "Tossicia",
      "primary": true,
      "skipSearch": false
    }],
    "castel-maidetto": [{
      "hkey": "4f233fe1",
      "slug": "tossicia",
      "name": "Tossicia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5d6b38ff": [{
      "hkey": "4f233fe1",
      "slug": "tossicia",
      "name": "Tossicia",
      "primary": true,
      "skipSearch": false
    }],
    "chiarino": [{
      "hkey": "4f233fe1",
      "slug": "tossicia",
      "name": "Tossicia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7d69ce58": [{
      "hkey": "4f233fe1",
      "slug": "tossicia",
      "name": "Tossicia",
      "primary": true,
      "skipSearch": false
    }],
    "palozza": [{
      "hkey": "4f233fe1",
      "slug": "tossicia",
      "name": "Tossicia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "42bb6af5": [{
      "hkey": "4f233fe1",
      "slug": "tossicia",
      "name": "Tossicia",
      "primary": true,
      "skipSearch": false
    }],
    "tozzanella": [{
      "hkey": "4f233fe1",
      "slug": "tossicia",
      "name": "Tossicia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "41ae3b1b": [{
      "hkey": "4f233fe1",
      "slug": "tossicia",
      "name": "Tossicia",
      "primary": true,
      "skipSearch": false
    }],
    "villa-alzano": [{
      "hkey": "4f233fe1",
      "slug": "tossicia",
      "name": "Tossicia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;